import ApuracaoAcaoDetalhesInforAcaoPrevia from '../../produto/spa/apuracao-acao/ApuracaoAcaoDetalhesInforAcaoPrevia';

export default ApuracaoAcaoDetalhesInforAcaoPrevia;
